import { render, staticRenderFns } from "./SPRsPage.vue?vue&type=template&id=9bb46f4e&scoped=true&"
import script from "./SPRsPage.vue?vue&type=script&lang=js&"
export * from "./SPRsPage.vue?vue&type=script&lang=js&"
import style0 from "./SPRsPage.vue?vue&type=style&index=0&id=9bb46f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb46f4e",
  null
  
)

export default component.exports